import React, { useState } from "react";
import { Text } from "react-konva";
import { IRect } from "utils/math-utils";
import { getFillAndOpacity, ORG_CHART_NODE_TEXT_STYLES, OrgChartNodeTextStyles } from "./utils";
import { OverflowTooltipOverlay } from "./overflow-tooltip-overlay";
import { Sizes } from "frontend/data/shapes/sizes";

export function OrgChartViewOnlyTextField({
  initialValue,
  rect,
  fieldTitle,
  textStyleId = "default",
  textColor,
}: {
  initialValue: string;
  rect: IRect;
  fieldTitle: string;
  textStyleId?: OrgChartNodeTextStyles;
  textColor: string;
}) {
  const { fill, opacity } = getFillAndOpacity(initialValue, textStyleId, textColor);
  const displayText = (initialValue || fieldTitle || "").trim();

  const [isHovering, setIsHovering] = useState(false);

  return (
    <>
      <Text
        x={rect.x}
        y={rect.y}
        width={rect.width}
        height={rect.height}
        fill={fill}
        opacity={opacity}
        {...ORG_CHART_NODE_TEXT_STYLES[textStyleId]}
        fontSize={Sizes.get().orgChart.fontSize[textStyleId]}
        text={displayText}
        listening={false}
      />
      <OverflowTooltipOverlay
        rect={rect}
        displayText={displayText}
        textStyleId={textStyleId}
        fieldTitle={fieldTitle}
        isHovering={isHovering}
        setIsHovering={setIsHovering}
      />
    </>
  );
}
